module.exports = __webpack_public_path__ + "static/media/Calendar-red.44a52e65.svg";